import styles from "./Labels.module.css";

const InfoLabel = ({ identifier, text }) => {
  return (
    <div className={styles.infoTextDiv}>
      <p className={styles.infoText} id={identifier} name={identifier}>
        {text}
      </p>
    </div>
  );
};

export default InfoLabel;
